import React from 'react';
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import VW from '../Assets/VW-logo.png'

const Footer = () => {
    return (
        <footer className="bg-gradient-to-r from-slate-800 to-slate-700 text-slate-200 mt-auto">
            <div className="max-w-7xl mx-auto px-5 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
                    <div className="ml-6 max-w-sm">
                        <div className="flex items-center">
                            <Link to="/">
                                <div className=" cursor-pointer ">
                                    <img
                                        src={VW}
                                        alt="Logo"
                                        className="w-50 h-auto "
                                    />
                                </div>
                            </Link>
                        </div>
                       
                    </div>


                    {/* Quick Links */}
                    <div>
                        <h4 className="text-white font-bold mb-4">Quick Links</h4>
                        <ul className="space-y-2">
                            <li>
                                <a href="/about" className="text-slate-300 hover:text-white transition-colors">
                                    About Us
                                </a>
                            </li>
                            <li>
                                <a href="/service" className="text-slate-300 hover:text-white transition-colors">
                                    Services
                                </a>
                            </li>
                            <li>
                                <a href="/pricing" className="text-slate-300 hover:text-white transition-colors">
                                    Pricing
                                </a>
                            </li>
                            <li>
                                <a href="/contact" className="text-slate-300 hover:text-white transition-colors">
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Resources */}
                    <div>
                        <h4 className="text-white font-bold mb-4">Resources</h4>
                        <ul className="space-y-2">
                            
                            <li>
                                <a href="/support" className="text-slate-300 hover:text-white transition-colors">
                                    Support Center
                                </a>
                            </li>
                            <li>
                                <a href="/privacy" className="text-slate-300 hover:text-white transition-colors">
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a href="/terms" className="text-slate-300 hover:text-white transition-colors">
                                    Terms of Service
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="text-white font-bold mb-4">Contact Us</h4>
                        <ul className="space-y-3 ml-8">
                            <li className="flex items-start space-x-3">
                                <Mail className="w-5 h-5 text-blue-400 mt-0.5" />
                                <span className="text-slate-300 text-sm">info@viewwiser.com</span>
                            </li>
                            <li className="flex items-start space-x-3">
                                <Phone className="w-5 h-5 text-blue-400 mt-0.5" />
                                <span className="text-slate-300 text-sm">+91-9980504877</span>
                            </li>
                            <li className="flex items-start space-x-3">
                                <MapPin className="w-5 h-5 text-blue-400 mt-0.5" />
                                <span className="text-slate-300 text-sm">
                                    Bengaluru, Karnataka, India
                                </span>
                            </li>
                        </ul>
                        <div className="flex space-x-4 mt-4 ml-8">
                            <a
                                href="https://www.facebook.com/Viewwiser"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 bg-slate-600 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors"
                            >
                                <Facebook className="w-5 h-5 text-white" />
                            </a>

                            <a
                                href="https://www.linkedin.com/company/viewwiser-techonologies/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 bg-slate-600 hover:bg-blue-700 rounded-lg flex items-center justify-center transition-colors"
                            >
                                <Linkedin className="w-5 h-5 text-white" />
                            </a>

                        </div>
                    </div>
                </div>

                {/* Social Media & Bottom Bar */}
                <div className="border-t border-slate-600 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        {/* Social Media Links */}
                        {/* Copyright */}
                        <div className="w-full text-center text-slate-400 text-sm">
                            © {new Date().getFullYear()} Viewwiser Technologies Private Limited. All rights reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;